import { Rule } from '@webkit/validation/value';
import dayjs from 'dayjs';

import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(isSameOrBefore);

export const before = (date: dayjs.Dayjs, inclusive: boolean = false, error?: string) =>
    ({
        id: 'before',
        validator: value => !value || (inclusive ? value.isSameOrBefore(date) : value.isBefore(date)),
        error: () => error || `Must be ${inclusive ? 'on or ' : ''}before ${date.format('M/D/YYYY')}`,
    } as Rule<dayjs.Dayjs | null>);
